// This is just for the Loading or Error Selector
export const GET_SERVICES = 'GET_SERVICES';

// Use these for Actions
export const GET_SERVICES_REQUEST = 'GET_SERVICES_REQUEST';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICES_ERROR = 'GET_SERVICES_ERROR';
